<template>
  <v-container>
    <v-radio-group v-model="ein">
      <v-radio :value="true" label="Legal House gets the EIN" />
      <v-radio :value="false" label="I'll get my own EIN" />
    </v-radio-group>
    <v-layout justify-space-around>
      <v-btn @click="$router.go(-1);">Back</v-btn>
      <v-btn color="info" @click="done">Continue</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';

const db = firebase.database;

export default {
  data: () => ({
    ein: true,
  }),
  computed: mapState(['token']),
  methods: {
    async done() {
      await db()
        .ref(`info/${this.token}`)
        .update(this.$data);
      this.$router.push({ path: 'opagree' });
    },
  },
};
</script>
